///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/p/card-capture.js
///include /assets/js/app/p/direct-debit-capture.js
///include /assets/js/app/s/checkout-info.js
///include /assets/js/app/p/payment-info-capture.js

const SPaymentSelection = Vue.extend({
    template: "#payment-selection",
    props: {
        currency: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        model: {
            required: true,
        },
        single: {
            type: Boolean,
            required: false,
            default: false,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        const vue = this
        return {
            /** @type {?boolean} */
            canCapture: null,
            checkoutInfo: CheckoutInfo.inst,
            paymentItemCollection: PaymentItemCollection.inst,
            /**
             * @type {?SPaymentItem}
             */
            selectedItem: null,
            showCaptureInline: false,
            submittingCapture: false,

            get selectablePaymentItems() {
                if(!this.paymentItemCollection.items) return null
                return this.paymentItemCollection.items.filter(
                    pi => (pi.type == vue.type) && pi.isBillable
                )
            },
            async showAdd() {
                if(vue.type == "card") {
                    setTimeout(() => {
                        this.showCaptureInline = true
                    }, 1000);
                    const pf = vue.$el.querySelector("#payment-form")
                    if(pf instanceof HTMLFormElement) {
                        await PaymentInfoCapture.initForm(pf)
                    }
                }
                vue.$emit("adding", vue.type)
                const type_driver = PaymentInfoCapture.drivers[vue.type]
                if(type_driver) {
                    const pg_driver = await type_driver.getDriver()
                    if(pg_driver && !await pg_driver.startAdd(vue.currency)) {
                        console.log("PG driver intercepted the add form")
                        return
                    }
                }
                $(vue.$el).find(".modal").modal("show")
            },
        }
    },
    computed: {
        showInline() {
            return this.showCaptureInline
        },
        showPaymentItems() {
            return !this.showCaptureInline
        }
    },
    methods: {
        closeInlineCapture() {
            this.showCaptureInline = !this.showCaptureInline
        },
        formatLabel(paymentItemLabel) {
            const regex = /(\d{4})\s/g

            if (
                typeof paymentItemLabel == "string" &&
                regex.test(paymentItemLabel)
            ) {
                const html = paymentItemLabel.replace(regex, '$1<br>')
                return html
            }

            return paymentItemLabel
        }
    },
    watch: {
        model(v) {
            this.selectedItem = v
        },
        selectedItem(v) {
            this.$emit("update:model", v)
        },
        selectablePaymentItems(v) {
            const enabled_items = v.filter(
                pi => pi.isEnabled
            )
            if(enabled_items.length == 1) {
                this.selectedItem = enabled_items[0]
            }
        }
    },
    async mounted() {
        this.selectedItem = this.model
        if(this.type == "card") {
            const driver = await PaymentInfoCapture.drivers.card.getDriver()
            this.canCapture = driver ? driver.canCapture : null
        } else {
            this.canCapture = true
        }
        $(this.$el).find(".modal")
            .on("hidden.bs.modal", () => this.$emit("adding", null))
    },
})
